import { Reveal, SectionLabel } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const H = ({ children }) => (
  <h2 className="mt-12 font-serif text-2xl text-foam first:mt-0">{children}</h2>
);
const P = ({ children }) => (
  <p className="mt-4 text-sm leading-relaxed text-foam/65">{children}</p>
);

export default function MentionsLegales() {
  const { tr } = useLang();
  return (
    <main className="min-h-screen bg-abyss pt-[72px] pb-24" data-testid="mentions-page">
      <div className="mx-auto max-w-3xl px-5 pt-14 md:px-10">
        <Reveal>
          <SectionLabel>{tr("Informations légales")}</SectionLabel>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl font-light text-foam">
            {tr("Mentions légales & CGU")}
          </h1>
          <p className="mt-4 text-xs text-foam/50">
            {tr("Mentions légales officielles de l'École Française de Janzu — OJANZU (texte repris de janzu.fr/mentions-légales).")}
          </p>
        </Reveal>

        <Reveal delay={0.08} amount={0.02}>
          <div className="glass-card mt-10 rounded-2xl p-6 md:p-10" data-testid="mentions-content">
            <P>
              En application du Code Français de la Propriété Intellectuelle et, plus généralement, des traités et accords internationaux comportant des dispositions relatives à la protection des droits d'auteurs, vous vous interdirez de reproduire pour un usage autre que privé, vendre, distribuer, émettre, diffuser, adapter, modifier, publier, communiquer intégralement ou partiellement, sous quelque forme que ce soit, les données, la présentation ou l'organisation du site internet www.janzu.fr ou les œuvres protégées par le droit d'auteur qui figurent sur le site internet www.janzu.fr sans autorisation écrite particulière et préalable du détenteur du droit d'auteur attaché à l'œuvre, à la présentation ou à l'organisation du site ou à la donnée reproduite.
            </P>

            <H>1. Édition / Publication</H>
            <P>
              En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site www.janzu.fr l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi :
            </P>
            <P>L'adresse de notre site Web est : www.janzu.fr</P>
            <P>Propriétaire : STÉPHANIE VAUTEY – 2 rue de Gringoland, 17250 La Vallée, France – stephanie@janzu.fr</P>
            <P>Responsable publication : STÉPHANIE VAUTEY – 2 rue de Gringoland, 17250 La Vallée, France – stephanie@janzu.fr</P>
            <P>Le responsable publication est une personne physique ou une personne morale.</P>
            <P>Webmaster : Agence Close-up – 02.90.73.53.13</P>
            <P>Hébergeur : Emergent (emergent.host)</P>

            <H>2. Conditions générales d'utilisation du site et des services proposés</H>
            <P>
              L'utilisation du site www.janzu.fr implique l'acceptation pleine et entière des conditions générales d'utilisation ci-après décrites. Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment, les utilisateurs du site www.janzu.fr sont donc invités à les consulter de manière régulière.
            </P>
            <P>
              Ce site est normalement accessible à tout moment aux utilisateurs. Une interruption pour raison de maintenance technique peut être toutefois décidée par www.janzu.fr, qui s'efforcera alors de communiquer préalablement aux utilisateurs les dates et heures de l'intervention.
            </P>
            <P>
              Le site www.janzu.fr est mis à jour régulièrement. De la même façon, les mentions légales peuvent être modifiées à tout moment : elles s'imposent néanmoins à l'utilisateur qui est invité à s'y référer le plus souvent possible afin d'en prendre connaissance.
            </P>

            <H>3. Description des services fournis</H>
            <P>
              Le site www.janzu.fr a pour objet de fournir une information concernant l'ensemble des activités de la société.
            </P>
            <P>
              www.janzu.fr s'efforce de fournir sur le site des informations aussi précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
            </P>
            <P>
              Toutes les informations indiquées sur le site www.janzu.fr sont données à titre indicatif, et sont susceptibles d'évoluer. Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs. Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne.
            </P>

            <H>4. Limitations contractuelles sur les données techniques</H>
            <P>
              Le site Internet ne pourra être tenu responsable de dommages matériels liés à l'utilisation du site. De plus, l'utilisateur du site s'engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis à jour.
            </P>

            <H>5. Propriété intellectuelle et contrefaçons</H>
            <P>
              www.janzu.fr est propriétaire des droits de propriété intellectuelle ou détient les droits d'usage sur tous les éléments accessibles sur le site, notamment les textes, images, graphismes, logo, icônes, sons, logiciels.
            </P>
            <P>
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de www.janzu.fr.
            </P>
            <P>
              Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
            </P>

            <H>6. Limitations de responsabilité</H>
            <P>
              www.janzu.fr ne pourra être tenu responsable des dommages directs et indirects causés au matériel de l'utilisateur, lors de l'accès au site www.janzu.fr, et résultant soit de l'utilisation d'un matériel ne répondant pas aux spécifications indiquées au point 4, soit de l'apparition d'un bug ou d'une incompatibilité.
            </P>

            <H>7. Gestion des données personnelles</H>
            <P>
              En France, les données personnelles sont notamment protégées par la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004, l'article L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995.
            </P>
            <P>
              À l'occasion de l'utilisation du site www.janzu.fr, peuvent être recueillies : l'URL des liens par l'intermédiaire desquels l'utilisateur a accédé au site www.janzu.fr, le fournisseur d'accès de l'utilisateur, l'adresse de protocole Internet (IP) de l'utilisateur.
            </P>
            <P>
              Pour la collecte et le traitement des données personnelles liées aux commandes et à la création de compte, se référer à l'article 7 des Conditions Générales de Vente (Politique de confidentialité et de traitement des données personnelles).
            </P>
            <P>
              Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données.
            </P>

            <H>8. Liens hypertextes et cookies</H>
            <P>
              Le site www.janzu.fr contient un certain nombre de liens hypertextes vers d'autres sites, mis en place avec l'autorisation de www.janzu.fr. Cependant, www.janzu.fr n'a pas la possibilité de vérifier le contenu des sites ainsi visités, et n'assumera en conséquence aucune responsabilité de ce fait.
            </P>
            <P>
              La navigation sur le site www.janzu.fr est susceptible de provoquer l'installation de cookie(s) sur l'ordinateur de l'utilisateur. Un cookie est un fichier de petite taille, qui ne permet pas l'identification de l'utilisateur, mais qui enregistre des informations relatives à la navigation d'un ordinateur sur un site. Les données ainsi obtenues visent à faciliter la navigation ultérieure sur le site, et ont également vocation à permettre diverses mesures de fréquentation.
            </P>
            <P>
              Le refus d'installation d'un cookie peut entraîner l'impossibilité d'accéder à certains services. L'utilisateur peut toutefois configurer son ordinateur pour refuser l'installation des cookies, dans les réglages de confidentialité de son navigateur (Chrome, Firefox, Safari, Edge).
            </P>

            <H>9. Droit applicable et attribution de juridiction</H>
            <P>
              Tout litige en relation avec l'utilisation du site www.janzu.fr est soumis au droit français. Il est fait attribution exclusive de juridiction aux tribunaux compétents.
            </P>

            <H>10. Les principales lois concernées</H>
            <P>
              Loi n° 78-17 du 6 janvier 1978, notamment modifiée par la loi n° 2004-801 du 6 août 2004 relative à l'informatique, aux fichiers et aux libertés.
            </P>
            <P>Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique.</P>

            <H>11. Lexique</H>
            <P>Utilisateur : Internaute se connectant, utilisant le site susnommé.</P>
            <P>
              Informations personnelles : « les informations qui permettent, sous quelque forme que ce soit, directement ou non, l'identification des personnes physiques auxquelles elles s'appliquent » (article 4 de la loi n° 78-17 du 6 janvier 1978).
            </P>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
